import CtaLink2 from "@/ui/atoms/CtaLink2"
import { CtaData } from "@/ui/types/cta"
import { classNames } from "@punks/ui-core"

export interface CtaLinkListProps {
  items: CtaData[]
  direction?: "row" | "column"
  className?: string
  align?: "start" | "center" | "end"
}

const CtaLinkList = ({
  items,
  direction = "row",
  className,
  align = "start",
}: CtaLinkListProps) => {
  return (
    <div
      className={classNames(
        {
          "flex flex-col space-y-4": direction === "column",
          "flex flex-row space-x-4": direction === "row",
          "justify-start": align === "start",
          "justify-center": align === "center",
          "justify-end": align === "end",
        },
        className
      )}
    >
      {items.map((item, index) => (
        <CtaLink2 key={index} {...item} />
      ))}
    </div>
  )
}

export default CtaLinkList
